import React from 'react';
import { IfmsRoute }from '../../../config/types';

const ReferenceFiles= React.lazy(() => import('../ReferenceFiles'));


const routes:Array<IfmsRoute> = [
  {path: '/referenceFiles', component: ReferenceFiles},
];

export default routes;